<hlm-popover
  class="w-full"
  align="start"
  [state]="overlayState()"
  (stateChanged)="onStateChanged($event)"
>
  <button
    #trigger
    type="button"
    hlmPopoverTrigger
    class="table-filter-dropdown__trigger"
    [class.table-filter-dropdown__trigger--active]="selectedCount() > 0"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen()"
    (click)="onTriggerClick()"
    (keydown.space)="$event.preventDefault()"
  >
    <span class="table-filter-dropdown__label">{{ label() }}</span>
    @if (selectedCount() > 0) {
      <span class="table-filter-dropdown__count">{{ selectedCount() }}</span>
    }
    <ocp-themed-icon class="table-filter-dropdown__chevron" name="chevron-down.svg" [size]="7" />
  </button>

  <hlm-popover-content *hlmPopoverPortal class="w-fit p-2.5" [style.min-width]="triggerWidth()">
    <div
      class="table-filter-dropdown__list"
      role="listbox"
      aria-multiselectable="true"
      [attr.aria-label]="label()"
    >
      <div
        [id]="getRowId(0)"
        role="option"
        class="table-filter-dropdown__option"
        [class.table-filter-dropdown__option--selected]="selectedCount() === 0"
        [attr.aria-selected]="selectedCount() === 0"
        [attr.tabindex]="focusedIndex() === 0 ? 0 : -1"
        (click)="onShowAllClick($event)"
        (keydown)="onRowKeydown($event, 0)"
      >
        <span class="table-filter-dropdown__checkmark-area">
          @if (selectedCount() === 0) {
            <ocp-themed-icon
              class="table-filter-dropdown__checkmark"
              name="checkmark.svg"
              [size]="16"
            />
          }
        </span>
        {{ showAllLabel() }}
      </div>

      @for (option of options(); track trackByValue($index, option); let i = $index) {
        <div
          [id]="getRowId(i + 1)"
          role="option"
          class="table-filter-dropdown__option"
          [class.table-filter-dropdown__option--selected]="isSelected(option)"
          [attr.aria-selected]="isSelected(option)"
          [attr.tabindex]="focusedIndex() === i + 1 ? 0 : -1"
          (click)="onOptionClick(option, $event)"
          (keydown)="onRowKeydown($event, i + 1)"
        >
          <span class="table-filter-dropdown__checkmark-area">
            @if (isSelected(option)) {
              <ocp-themed-icon
                class="table-filter-dropdown__checkmark"
                name="checkmark.svg"
                [size]="16"
              />
            }
          </span>
          @if (option.modifier) {
            <span
              class="table-filter-dropdown__option-pill"
              [class.table-filter-dropdown__option-pill--open]="option.modifier === 'open'"
              [class.table-filter-dropdown__option-pill--resolved]="option.modifier === 'resolved'"
              [class.table-filter-dropdown__option-pill--closed]="option.modifier === 'closed'"
              [class.table-filter-dropdown__option-pill--low]="option.modifier === 'low'"
              [class.table-filter-dropdown__option-pill--medium]="option.modifier === 'medium'"
              [class.table-filter-dropdown__option-pill--high]="option.modifier === 'high'"
            >
              @if (
                option.modifier === 'low' ||
                option.modifier === 'medium' ||
                option.modifier === 'high'
              ) {
                <span
                  class="table-filter-dropdown__option-dot"
                  [class.table-filter-dropdown__option-dot--low]="option.modifier === 'low'"
                  [class.table-filter-dropdown__option-dot--medium]="option.modifier === 'medium'"
                  [class.table-filter-dropdown__option-dot--high]="option.modifier === 'high'"
                ></span>
              }
              @if (option.labelKey) {
                {{ option.labelKey | translate }}
              } @else {
                {{ option.label }}
              }
            </span>
          } @else if (option.labelKey) {
            {{ option.labelKey | translate }}
          } @else {
            <ocp-avatar
              [userInitials]="option.label | initials"
              [colorSeed]="option.email"
              size="md"
              class="table-filter-dropdown__option-avatar"
            />
            {{ option.label }}
          }
        </div>
      }
    </div>
  </hlm-popover-content>
</hlm-popover>
